import { render, staticRenderFns } from "./reliquat.html?vue&type=template&id=2a39f910&scoped=true&external"
import script from "./reliquat.js?vue&type=script&lang=js&external"
export * from "./reliquat.js?vue&type=script&lang=js&external"
import style0 from "./reliquat.scss?vue&type=style&index=0&id=2a39f910&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a39f910",
  null
  
)

export default component.exports